import type { IconNode } from '../types';

/**
 * @name elephant-face
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTBhNCA0IDAgMCAwIDQgNCAyIDIgMCAwIDEgMCA0IDcgNyAwIDAgMS0yLjgtLjZjLS41LS4yLS45IDAtMSAuNmwtLjEgMS0uOS45Yy0uNC40LS4zLjkuMiAxLjIgMS40LjYgMyAuOSA0LjYuOSAzLjMgMCA2LTIuNyA2LTZWOGE0IDQgMCAwIDAtNC00aC00LjZjLS43LTEuMi0yLTItMy40LTJINkM0LjMgMiAzIDMuMyAzIDV2MWE3IDcgMCAwIDAgNyA3aDIuNCIgLz4KICA8cGF0aCBkPSJNMTUuNSAxMEgxNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/elephant-face
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const elephantFace: IconNode = [
  [
    'path',
    {
      d: 'M11 10a4 4 0 0 0 4 4 2 2 0 0 1 0 4 7 7 0 0 1-2.8-.6c-.5-.2-.9 0-1 .6l-.1 1-.9.9c-.4.4-.3.9.2 1.2 1.4.6 3 .9 4.6.9 3.3 0 6-2.7 6-6V8a4 4 0 0 0-4-4h-4.6c-.7-1.2-2-2-3.4-2H6C4.3 2 3 3.3 3 5v1a7 7 0 0 0 7 7h2.4',
      key: '2ab4y9',
    },
  ],
  ['path', { d: 'M15.5 10H15', key: 'rkkthh' }],
];

export default elephantFace;
